var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-simple input[type=mail],.form-simple input[type=text]{margin-bottom:-1px;border-bottom-right-radius:0;border-bottom-left-radius:0}.form-simple input[type=mail],.form-simple input[type=password]{border-top-left-radius:0;border-top-right-radius:0}.mb-otstup{margin-bottom:.4rem!important}.help-block ul{margin:0!important;padding:0!important}.help-block ul li{list-style:none}.bg-maintenance-image{background-image:url(" + escape(require("../pictures/bg-2.jpg")) + ");background-repeat:no-repeat;background-size:cover}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/assets/css/login-register.css
// module id = 1165
// module chunks = 0